import API from './api';

const url_base = process.env.REACT_APP_API_HUB;
const url_modulo = 'financeiro/v1';

export const getListaRemessas = filtros =>
  API.get(`${url_base}/${url_modulo}/remessas`, { params: filtros });

export const getFiltroEmpresas = () => API.get(`${url_base}/${url_modulo}/remessas/filtros/empresas`);

export const getFiltroCarteiras = () => API.get(`${url_base}/${url_modulo}/remessas/filtros/carteiras`);

export const getFiltroOcorrenciasBancarias = () =>
  API.get(`${url_base}/${url_modulo}/remessas/filtros/ocorrencias-bancarias`);

export const getFiltroTiposDocumento = () =>
  API.get(`${url_base}/${url_modulo}/remessas/filtros/tipos-documento`);

export const getFiltroBancos = () => API.get(`${url_base}/${url_modulo}/remessas/filtros/bancos`);

export const getContasCobranca = codEmpresa =>
  API.get(`${url_base}/${url_modulo}/remessas/contas-cobranca/${codEmpresa}`);

export const criarRemessa = params => API.post(`${url_base}/${url_modulo}/remessas/incluir`, params);
